const US_VS_KLONDIKE_RCV250_AND_FANS_ADDRESS = `
Horton, Inc.<br/>
Attention: Warranty<br/>
301 Oconee Business Parkway<br/>
Westminster, SC 29693<br/>
UPS 4785W9
`;

const US_DM_A_OTHER_ADDRESS = `
Horton, Inc.<br/>
Attention: Warranty<br/>
10863 423rd Avenue NE<br/>
Britton, SD 57430<br/>
UPS 571145
`;

const CA_ADDRESS = `
Vision Transportation<br/>
6495 Tomken Rd.<br/>
Mississauga, ON<br/>
L5T 2X7
`;

const MX_ADDRESS = `
Horton, Inc.<br/>
S.D. de R.L. de C.V.<br/>
Blvd. Palmas Hills Lote 1 Y 2 Manzana II, OF 1803<br/>
Palmas Hills<br/>
Huixquilucan, Estado de México
`;

function getAddressByForm(): string {
	return getAddressByAttributes((document.getElementById("input_5_19") as HTMLSelectElement|null)?.value, document.querySelector<HTMLInputElement>("input[name='input_73']:checked")?.value);
}

function getAddressByAttributes(country: string|undefined|null, failedPartType: string|undefined|null): string {
	switch(country) {
		case "":
			return "Please select your Country to see Shipping Details";
		case "country-dealer-us":
			switch (failedPartType) {
				case "VS":
				case "Klondike (K32)":
				case "RCV250":
				case "Fans":
					return US_VS_KLONDIKE_RCV250_AND_FANS_ADDRESS;
				case "DM/DMA":
				case "All Other":
					return US_DM_A_OTHER_ADDRESS;
				default:
					return "Contact Horton for further instructions.";
			}
		case "country-dealer-ca":
			return CA_ADDRESS;
		case "country-dealer-mx":
			return MX_ADDRESS;
		default:
			return "Contact Horton for further instructions.";
	}
}

function attachDLs() {
	for (const dl of document.querySelectorAll("dl.horton-shipping-address-printer")) {
		for (const dd of dl.querySelectorAll("dd")) {
			dd.closest(".hidden-address-placeholder")?.classList.remove("hidden-address-placeholder");
			if (dd.innerHTML === '{ADDRESS_HERE}') {
				dd.innerHTML = getAddressByAttributes(dl.getAttribute("data-country"), dl.getAttribute("data-failed-part-type"))
					.replace(/^[^<\r\n]+<br\s*\/?>\s*/is, "")
					.replace(/\s*<br\s*\/?>\s*UPS\s+\w+\s*$/i, "").replace("Attention: Warranty<br/>", "").trim().replaceAll(/\s*<br\s*\/?>\s*/gi, ", ");
			}
		}
	}
}

const wireUpWarrantyFormDynamicAddress = () => {
	const dynamicAddressDisplayArea = document.getElementById("field_5_77");
	if (!dynamicAddressDisplayArea || dynamicAddressDisplayArea.classList.contains("dynamic-address-attached")) {
		attachDLs();
		return;
	}
	const initialHTML = dynamicAddressDisplayArea.innerHTML;
	dynamicAddressDisplayArea.classList.add("dynamic-address-attached");
	const dynamicAddressUpdater = () => {
		dynamicAddressDisplayArea.innerHTML = initialHTML.replaceAll("{ADDRESS_HERE}", getAddressByForm());
	};

	dynamicAddressUpdater();
	dynamicAddressDisplayArea.closest("form")?.addEventListener('change', dynamicAddressUpdater);
	attachDLs();
};
new MutationObserver(wireUpWarrantyFormDynamicAddress).observe(document.body, {childList: true, subtree: true});
wireUpWarrantyFormDynamicAddress();
